import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  E_LIBRARY,
  E_LIBRARY_ALL,
  E_LIBRARY_CREATE,
  E_LIBRARY_DELETE,
  E_LIBRARY_LIST,
  E_LIBRARY_TYPES,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const eLibrarySelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const eLibrarySelector = createSelector(eLibrarySelectors, state => state[E_LIBRARY])

export const eLibraryAllSelector = createSelector(eLibrarySelectors, state => state[E_LIBRARY_ALL])

export const eLibraryCreateSelector = createSelector(eLibrarySelectors, state => state[E_LIBRARY_CREATE])

export const eLibraryDeleteSelector = createSelector(eLibrarySelectors, state => state[E_LIBRARY_DELETE])

export const eLibraryListSelector = createSelector(eLibrarySelectors, state => state[E_LIBRARY_LIST])

export const eLibraryTypesSelector = createSelector(eLibrarySelectors, state => state[E_LIBRARY_TYPES])
